module.exports = __webpack_public_path__ + "static/media/stripe-create-account_3.e67a4af1.png";